import { paths } from '../../types/api/Authentication';
import { getFromGalaxy, handleErrorCategory } from '../api';
import config from '../config';

type DeepLinkLoginAppEndpoint = paths['/v2/firebase/deep-link-login-app']['get'];

export const getDeepLinkLoginApp = ({
  email,
}: Required<DeepLinkLoginAppEndpoint['parameters']['query']>) =>
  getFromGalaxy<DeepLinkLoginAppEndpoint['responses']['200']['content']['application/json']>(
    `authentication/v2/firebase/deep-link-login-app?email=${encodeURIComponent(email)}`,
  );

export const getSignUpWithEmailLink = async ({ email }: { email: string }) => {
  const response = await fetch(`${config.API_URL}authentication/v2/firebase/email-link`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      email,
      url: `${config.HOST_URL}/my-dashboard`,
    }),
  });
  if (!response.ok) {
    const error = await handleErrorCategory('Api', response);
    throw error;
  }
};
